module.exports = __webpack_public_path__ + "img/connections_dots_long_dark.1ad05242.svg";